export const Loader = () => {
  return (
    <div className="min-h-screen flex justify-center items-center">
      <div
        className="animate-spin w-16 h-16 border-8 rounded-full border-t-sky-500"
        role="status"
      ></div>
    </div>
  );
};
